import { GlobalRoles } from '../data-models/global-roles.model';
import { AuthUser } from '../data-models/auth-user.model';

/**
 * Helper functions for role checking
 * @deprecated Use CustomClaims methods directly (e.g., user.customClaims?.hasGlobalRole())
 */
export class UserRoleHelper {
  /**
   * Check if user has specific global role
   * @deprecated Use user.customClaims?.hasGlobalRole() instead
   */
  static hasRole(user: AuthUser, role: GlobalRoles): boolean {
    if (!user.customClaims) return false;
    return user.customClaims.hasGlobalRole(role);
  }

  /**
   * Check if user has any of the specified roles
   * @deprecated Use user.customClaims?.hasAnyGlobalRole() instead
   */
  static hasAnyRole(user: AuthUser, roles: GlobalRoles[]): boolean {
    return roles.some(role => this.hasRole(user, role));
  }

  /**
   * Check if user has all specified roles
   * @deprecated Use user.customClaims?.hasAllGlobalRoles() instead
   */
  static hasAllRoles(user: AuthUser, roles: GlobalRoles[]): boolean {
    return roles.every(role => this.hasRole(user, role));
  }

  /**
   * Check if user has specific permission
   * @deprecated Permissions are not implemented in current CustomClaims structure
   */
  static hasPermission(user: AuthUser, permission: string): boolean {
    return false;
  }

  /**
   * Get all roles for user
   * @deprecated Use user.customClaims?.getGlobalRoles() instead
   */
  static getUserRoles(user: AuthUser): GlobalRoles[] {
    return user.customClaims?.getGlobalRoles() ?? [];
  }
}
